import { render, staticRenderFns } from "./PMPageCreationWrapper.vue?vue&type=template&id=5c653184&"
import script from "./PMPageCreationWrapper.vue?vue&type=script&lang=ts&"
export * from "./PMPageCreationWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./PMPageCreationWrapper.vue?vue&type=style&index=0&id=5c653184&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports